import * as React from "react";
import { Input, Modal, notification } from "antd";
import { linksOf, request } from "../../../services/cpln";
import { DeleteVolumeSnapshotReducerState, useRunDeleteVolumeSnapshotReducer } from "./reducer_deleteVolumeSnapshot";
import { VolumeSet } from "../../../schema/types/volumeSet/entity";

interface Props {
  volumeSet: VolumeSet;
  initialLocation?: string;
  initialVolumeIndex?: string;
  initialSnapshotName?: string;
  onClose: any;
  onDone: any;
  visible: boolean;
}

export const CommandModal_DeleteVolumeSnapshot: React.FC<Props> = ({
  volumeSet,
  initialLocation,
  initialVolumeIndex,
  initialSnapshotName,
  onClose,
  onDone,
  visible,
}) => {
  const selfLink = linksOf(volumeSet).self!;
  const [confirmationText, setConfirmationText] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const [state] = useRunDeleteVolumeSnapshotReducer(initialLocation, initialVolumeIndex, initialSnapshotName);
  const CONFIRMATION_TOKEN = React.useMemo(() => {
    return `${volumeSet.name}-${state.location}-${state.volumeIndex}-${state.snapshotName}`;
  }, [volumeSet.name, state.location, state.volumeIndex, state.snapshotName]);

  async function handleConfirm() {
    try {
      setIsLoading(true);

      const spec: DeleteVolumeSnapshotReducerState = JSON.parse(JSON.stringify(state));

      await request({
        method: "post",
        url: `${selfLink}/-command`,
        body: {
          type: "deleteVolumeSnapshot",
          spec: spec,
        },
      });
      onDone();
      notification.success({
        message: "Success",
        description: "Created Command.",
      });
    } catch (e) {
      let errorMessage = e?.response?.data?.message;
      if (!errorMessage) errorMessage = e.message;
      notification.warning({
        message: "Failed",
        description: errorMessage,
      });
      setIsLoading(false);
    }
  }

  let isValid = true;
  if (!state.location) isValid = false;
  if (!state.volumeIndex) isValid = false;
  if (confirmationText !== CONFIRMATION_TOKEN) isValid = false;

  return (
    <Modal
      open={visible}
      title="Delete Volume Snapshot"
      cancelButtonProps={{ type: "default", danger: false, disabled: isLoading }}
      okButtonProps={{ type: "primary", danger: true, disabled: isLoading || !isValid, loading: isLoading }}
      onCancel={onClose}
      onOk={handleConfirm}
      maskClosable={false}
      destroyOnHidden
    >
      <div className="flex flex-col gap-2">
        <div>Are you sure you want to delete this volume snapshot?</div>
        <div className="delete-modal-confirmation-warning mt-4">{`Type "${CONFIRMATION_TOKEN}" for confirming the delete action`}</div>
        <Input
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
          placeholder={`confirmation`}
        />
      </div>
    </Modal>
  );
};
